import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';

@Component({
  selector: 'app-base-popup',
  templateUrl: './base-popup.component.html',
  styleUrls: ['./base-popup.component.css']
})
export class BasePopupComponent implements OnInit {

  title:any;
  description:any;
  imgSrc:any;
  @Output()
  onHide = new EventEmitter();

  constructor(public bsModalRef: BsModalRef,public discussionService: DiscussionService) { }

  ngOnInit(): void {
  }

  closeModal() {
    this.onHide.emit(true);
    this.bsModalRef.hide();
  }

}
